import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import kiosk from './modules/kiosk'

export default new Vuex.Store({
  modules: {
    kiosk
  }
})
